<template>
  <AppDialog
    :show="show"
    title="Need help, can't track, or doesn't apply?"
    size="medium"
    append-to-body
    class="ar0227-need-help-dialog"
    @close="$emit('close')"
  >
    <a
      class="ar0227-help-link"
      :href="quickStartGuideUrl"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="quick-start-guide-link"
      @click="trackLink('quick_start_guide')"
    >
      <span class="material-symbols-rounded">library_books</span>
      <span>Read the Quick Start guide</span>
    </a>

    <div class="ar0227-help-faq">
      <h5>How do I start tracking time?</h5>
      <p>Download the desktop app. Then select a project and track time and activity to that project.</p>

      <h5>Where can I see the time I tracked?</h5>
      <p>You can view your time and activity in Hubstaff's web application.</p>

      <h5>Don't have a project?</h5>
      <p>
        To track time in Hubstaff, you need to create or select a project first.
        Without a project, time tracking won't be recorded properly.
      </p>
    </div>

    <button
      type="button"
      class="ar0227-help-link"
      data-testid="support-chat-link"
      @click="openSupportChat"
    >
      <img
        :src="HUBSTAFF_LOGO"
        class="ar0227-help-logo"
        alt=""
        width="32"
        height="32"
      >
      <span>Reach out to our support team</span>
    </button>

    <template #footer>
      <button
        type="button"
        class="btn btn-default"
        data-testid="continue-without-tracking-button"
        @click="continueWithoutTracking"
      >
        Continue without tracking time
      </button>
    </template>
  </AppDialog>
</template>

<script>
import { HUBSTAFF_LOGO } from '~/rails_assets';

export default {
  name: 'TrackTimeNeedHelpModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    quickStartGuideUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      HUBSTAFF_LOGO,
    };
  },
  methods: {
    trackLink(link) {
      this.$emit('track-link', link);
    },
    openSupportChat() {
      this.trackLink('support_chat');

      let attemptsLeft = 10;
      const tryOpen = () => {
        if (window.HubSpotConversations.widget.status().loaded) {
          window.HubSpotConversations.widget.open();

          return;
        }

        attemptsLeft -= 1;
        if (attemptsLeft >= 0) {
          setTimeout(tryOpen, 1000);
        } else {
          this.$appMessage('Support chat is unavailable right now. Please use the Quick Start guide.');
        }
      };

      if (window.HubSpotConversations) {
        tryOpen();
      } else {
        window.hsConversationsOnReady = window.hsConversationsOnReady || [];
        window.hsConversationsOnReady.push(tryOpen);
      }
    },
    continueWithoutTracking() {
      this.trackLink('continue_without_tracking');
      this.$emit('continue-without-tracking');
    },
  },
};
</script>
